import React, { useState, useRef, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import './index.scss'
import * as R from 'ramda'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'


interface SelectProps {
  options: FormItemState[] | undefined
  placeholder?: string
  value?: string
  id?: string
  defaultValue?: string
  onChange: (item: KeyValue, value: string) => void
}

const Select = (props: SelectProps) => {
  const intl = useIntl()
  const selectEl = useRef(null)
  const [showOptionsBox, setShowOptionsBox] = useState(false)
  const [optionsData, setOptionsData] = useState<FormItemState[]>([])
  const [activeOption, setActiveOption] = useState({
    id: '',
    label: props.defaultValue || ''
  })
  
  useEffect(() => {
    initData()
  }, [props.options])
  
  const initData = () => {
    if (!R.equals(optionsData, props.options)) {
      setActiveOption({id: '', label: ''})
      setOptionsData(props.options!)
    }
  }

  const removeOptionBox = useCallback(
    (e) => {
      if (e.target === selectEl.current || ~e.target.className.indexOf('active-label')) return
      openOrCloseOptionsWindow(false)
    },
    []
  )

  const openOrCloseOptionsWindow = (open) => {
    if (open) {
      document.body.addEventListener('click', removeOptionBox)
    } else {
      document.body.removeEventListener('click', removeOptionBox)
    }
    setShowOptionsBox(open)
  }

  const selectItem = (option: FormItemState) => {
    props.onChange({target: selectEl.current}, option.id)
    openOrCloseOptionsWindow(false)
    setActiveOption(option)
  }

  return <>
    <div id={props.id} ref={selectEl} className={classNames({"select": true, "opening": showOptionsBox})} onClick={(e) => {
      if (props.options) {
        openOrCloseOptionsWindow(true)
      }
    }}>
      <span className={classNames({
        'active-label': true,
        'placeholder': !activeOption.label
      })}>{ activeOption?.label ? intl.formatMessage({ id: activeOption.label }) : props.placeholder }</span>
      {showOptionsBox && props.options && <div className="option-box">
        {props.options.map((option: FormItemState) => <div className="option" key={option.id} onClick={(e) => {
          e.stopPropagation()
          selectItem(option)
        }}>{option.label && <FormattedMessage id={option.label} />}</div>)}
      </div>}
    </div>
  </>
}

export default Select